export default {
  audio: null,
  name: null,
  cue: null,
  loading: null,
  playing: null,
};
